export default {
  methods: {
    fireTrackingEvent(event, data, callback) {
      return new Promise(async (resolve, reject) => {
        if(!window.tracker && !window.dataLayer) reject('Analytics Tracker is not available')
        const hashedEmailData = await this.getHashedEmailData(data);
        if(data.formEmail) delete data.formEmail
        window.dataLayer && window.dataLayer.push( Object.assign({ event }, data, hashedEmailData) );
        window.tracker && window.tracker.fireEvent(event, data, resolve('Successfully triggered the tracking event'));
      })
    },

    async getHashedEmailData(data) {
      try {
        let userEmail;
        const userDetails = await window.msAuth.currentSession()
        if (userDetails.tokens) {
          userEmail = userDetails.tokens.idToken.payload.email;
        } else if (data.formEmail) {
          userEmail = data.formEmail;
        }
        if (userEmail) {
          return { hashedEmail: await window.msAuth.sha256(userEmail) }
        } else {
          return {}
        }
      } catch(err) {
        airbrake.notify(err);
        return {}
      }
    }
  }
}
